import { useMemo } from 'react'
import { SelectOption } from '../../../../containers/BulkSheetView/components/cellEditor/MultiSelectCellEditor'
import { PermissionPolicyOption } from '../../model/PermissionPolicyOption'
import { useAvailableFunctionsTooltipGetter } from './availableFunctionsTooltip'

export const useAttachablePermissionPolicyOptions = (
  permissionPolicyOptions: PermissionPolicyOption[]
) => {
  const { getAvailableFunctionsTooltipOfPermissionPolicy } =
    useAvailableFunctionsTooltipGetter()
  const attachablePermissionPolicyOptions: SelectOption[] = useMemo(
    () =>
      permissionPolicyOptions
        .filter(p => p.attachable)
        .map(p => ({
          value: p.uuid,
          label: p.name,
          tooltip: getAvailableFunctionsTooltipOfPermissionPolicy(p),
          disabled: p.attachedByDefault || !p.attachable,
        })),
    [permissionPolicyOptions, getAvailableFunctionsTooltipOfPermissionPolicy]
  )

  return attachablePermissionPolicyOptions
}
